<template>
    <split-pane  :min-percent='10' :default-percent='15' split="vertical"  style="background:white; height:99%">
        <template slot="paneL">
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium" clearable  ></el-input> 
            <el-tree :data="treeData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"    
                        :default-expanded-keys="expkeys"     
                        :style="{background:'#fff',overflow:'auto',height: scrollerHeight}"
                        highlight-current
                        v-loading="loadingtree"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"    
                        :filter-node-method="filterNode"
                        ref="eltree"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  >
                        <span  style="color:#F56C6C;font-size:14px;"><i class="iconfont icon-_shujuzidian" style="color:#F56C6C;font-size:18px;"></i> {{ node.label}} </span>
                    </span>                  
                    <span v-else  > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i>{{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>
        <template slot="paneR">
            <div class="ve-list-page ve-list-page--embedded ve-list-page--pane">
            <div style=" background:#fff; display:flex;line-height:30px;border-bottom:2px solid #389;padding-top:3px; " >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="disabled" @click="addRec" :underline="false"  ><span style="font-size:12px;">{{ $LANG('0095', '新增记录') }} </span></el-link>
                <el-input :placeholder="input_hold" v-model="textparam" size="small" style="width:400px;margin-left:20px;height:30px; ">
                    <el-select v-model="selparam" slot="prepend" :placeholder="$LANG('1675', '请选择列名')" clearable @change="elchange" style="width:140px;">
                        <span v-for="item in tableCol" :key='item.key'>
                            <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData"></el-button>
                </el-input>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
            <div style="width:100%" class="ve-list-page__table">
                <ve-table :columns="vueCol"
                        :table-data="baseData"
                        :columnHiddenOption="columnHiddenOption"
                        style="margin-top:2px;"
                        :border-around="true"
                        :border-x="true"
                        :border-y="true"
                        :fixed-header="true"
                        row-key-field-name="IDSEQ"
                        :row-style-option="rowStyleOption"
                        :cell-style-option="cellStyleOption"
                        :max-height="tabHeight"
                        :virtual-scroll-option="virtualScrollOption"
                        :scroll-width="0"
                        :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                        :column-width-resize-option="columnWidthResizeOption"
                        :cellSelectionOption="{enable: false}"
                        v-loading="loading"
                        id="base_dic_load"
                        ref="tabref">
                </ve-table>
            </div>
            <div style=" margin-bottom:2px;overflow: hidden;padding-left:5px;background:white;font-size:12px" class="ve-list-page__pagination">
                <div style="float: left;">
                    <Page :total="dataCount" :page-size="pageSize" show-total :current.sync="page" @on-change="changePage" ></Page>
                </div>
            </div>
            <el-dialog v-dialogDrag :visible.sync="addModal" width="900px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{type==='create'?$LANG('0095', '新增记录'):$LANG('0921', '修改记录')}}</span>
                </div>
                <Form ref="addForm" :model="formCol" :label-width="100"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tableCol" :key="index" >
                        <FormItem :label="$translate.getColTitle(item, $store.state.lang)" :prop="item.key" v-if="item.fhide==='N'" class="item-width">
                            <el-input type="text" :disabled="item.disabled==='Y'?true:false" v-model="formCol[item.key]"  style="width:100%;"  ></el-input>
                        </FormItem>
                    </span>
                </Form>                     
                <div slot="footer" >
                    <el-button type="info" size="small" style="margin-right:25px;"  @click="addModal=false">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small"  @click="modal_ok">{{ $LANG('1638', '确定') }}</el-button>
                </div>
            </el-dialog>
            <el-dialog  :show-close="false" :visible.sync="promptWin" width="420px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
                </div>
    
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <div slot="footer" style="height:35px;">
                    <Button type="primary"   @click="promptWin=false">{{ $LANG('1638', '确定') }}</Button>
                </div>
            </el-dialog >
            <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
            />
        </div>
        </template>
    </split-pane>
 
</template>

<script>
    import { getTabColOrData } from '../../api/user';
    import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
    import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
    export default {
        name: "base_dic",
        mixins: [
            createVeTableFieldSettingMixin({
                settingFormId: '19',
                fieldIdseq: '19',
                fieldLstseq: '1',
                mainColumnKey: 'tableCol',
                tableColumnKey: 'vueCol',
                initColumnKey: 'initCol',
                tableRef: 'tabref',
                generatedFixedColumnKeys: ['RN', 'oper'],
            })
        ],
        components: {
            VeColumnConfigDialog,
        },
        data(){
            return {
                treeData:[] ,//  树数据
                filterText: '',
                disabled:false,
                ruleValidate:{},
                nodeData:{},
                input_hold:'请输入内容...',
                defaultProps: {  //el-tree 默认字段属性
                    children: 'children',
                    id:'id',
                    icon:'icon',
                    label: 'label'
                },
                promptWin:false,
                prompt:'',
                notNull:[],
                expkeys:['0'],
                treeid :'0',
                type: 'create',
                v_sys:this.$cookies.get('v_sys'), //系统标志
                formCol:{}, //表格单行记录 model
                addModal:false, //modal 
                loading:false,// table加载bool
                loadingtree:false,
                textparam:'', // input 绑定值
                selparam:'',// select 绑定值
                tableCol:[] ,//表列格式化集合
                initCol:[],
                vueCol:[],
                columnHiddenOption: {
                    defaultHiddenColumnKeys: [],
                },
                rowStyleOption: { clickHighlight: true },
                cellStyleOption: {
                    bodyCellClass: ({ row, column, rowIndex }) => 'table-body-cell-class1',
                    headerCellClass: ({ column, rowIndex }) => (
                        column && column.field === '#'
                            ? 'table-head-cell-class2'
                            : 'table-head-cell-class'
                    ),
                },
                virtualScrollOption: { enable: false },
                v_inputrow:{},
                baseData:[] ,//表数据
                allData:[] , //保存取到所有数据
                nodeLabel:'数据字典',
                rowIndex:'-1', //行号
                page:1,
                stfgBool:true,
                // 初始化信息总条数
                dataCount:0,
           
                // 每页显示多少条
                pageSize:50,
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_url:'xuper_auth/getTableRecMany', //动态请求url接口
            }
        },
        created(){
            if (this.v_sys==='N'){ 
                this.disabled =true
            }
            if (this.v_username){ 
                //初始化
                this.getData(); //树形数据
                this.getTabCol(); //表列数据
                this.getTabData('parentno','0','','','',''); //表记录数据
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        mounted(){
            //动态生成表单验证规则
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','19','lstseq','1','NOTNULL','Y').then((res) => {
                let ruleObj={}
                let ruleVal=[]
                this.notNull = res.result
                res.result.forEach(item => {
                    let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                    let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                    ruleVal =[]
                    ruleVal.push(obj1)
                    ruleObj[item.FLDNO]=ruleVal                  
                });
                this.ruleValidate =ruleObj
            });
        },
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 125) + 'px';
            },
            tabHeight(){
                return window.innerHeight-155+ 'px'
            }  
            
        },
        watch:{
            filterText(val) {
                this.$refs.eltree.filter(val.toUpperCase());
            }
        },
        destroyed(){
        },
        methods:{
            getRowKeys(row){
 
                return row.IDSEQ
            },
            //节点过滤
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value.toUpperCase()) !== -1;
            },
            //节点点击
            handleNodeClick(data ){
                this.nodeLabel=data.label;            
                this.treeid =data.id
                this.qryTabData()
            },
 
            //确定
            modal_ok(){
                var vm=this;
                this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                    if (!this.formCol[item.FLDNO] ){
                       this.stfgBool =false 
                       this.prompt =item.FLDNM+'不能为空'
                       this.promptWin =true
                    }else{
                      this.stfgBool =true  
                    }
                })
                //发起保存请求   
                if (this.stfgBool) 
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.formCol), p_table:'sys_base'},
                    }).then(res=>{      
                        if(res.result =='OK')  {          
                            vm.addModal =false   
                            vm.getData()   
                            vm.qryTabData()
                        }else{
                            this.prompt =res.result
                            this.promptWin =true
                        }        
                    }) 
                //}
            } ,
            //新增
            addRec(){
                this.addModal =true
                this.type ='create' 
                this.formCol ={}
                this.formCol.PARENTNO =this.treeid
                this.formCol.PCNAME =this.nodeLabel
                
            },
            //修改
            editRec(row ){
                this.addModal =true
                this.type ='edit'
                this.formCol = JSON.parse(JSON.stringify(row)) //获取行数据,深拷呗
 
            },
            //删除
            delRec(row){
                if (row.ADDUSER==='ADMIN'){
                    this.prompt ='系统数据不能删除'
                    this.promptWin =true
                }else{
                    this.$Modal.confirm({
                        title: '删除确认',
                        content: '<p>你确定要删除此行记录吗</p>',
                        onOk: () => {
                            //发起删除请求
                            var vm=this;
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'code',p_value:row.CODE,p_table:'sys_base'},
                            }).then(res=>{      
                                if(res.code =='200')  {           
                                    vm.qryTabData()
                                    vm.getData()     
                                }else{
                                    this.prompt =res.message
                                    this.promptWin =true
                                }        
                            }) 
                        }
                    });
                }
            },
            //表格页面导航
            changePage(index){
                var _start = ( index - 1 ) * this.pageSize;
                var _end = index * this.pageSize
                this.page =index
                this.baseData = this.allData.slice(_start,_end);
            },
            // el-select 改变时 影响el-input 的 placeholder
            elchange(val){  // 这个val 就是 el-select 的 value
                let obj ={}
                obj =this.tableCol.find(item=>{
                    return item.key===val
                })
                this.input_hold=obj ? '请输入'+obj.title+' 的值' : this.$LANG('1692', '请输入查询值')
            },
            enterDown(event){
                if (event && (event.keyCode === 13 || event.key === 'Enter')) {
                    this.qryTabData()
                }
            },
            inputChg(event, column){
                const value = event && event.target ? event.target.value : ''
                this.$set(this.v_inputrow, column, value)
            },
            buildHeaderQueryCondition(){
                const searchableColumns =this.tableCol.reduce((result, item) => {
                    if (item && item.key && String(item.key).toUpperCase() !== 'RN') {
                        result[item.key] =true
                    }
                    return result
                }, {})
                return Object.keys(this.v_inputrow).reduce((condition, key) => {
                    const value =this.v_inputrow[key]
                    if (!searchableColumns[key] || value === null || value === undefined || String(value).trim() === '') {
                        return condition
                    }
                    const escapedValue =String(value).trim().replace(/'/g, "''")
                    return condition+` and ${key} like '%${escapedValue}%'`
                }, '')
            },
            rowShow(){
                this.v_inputrow = {}
                this.qryTabData()
            },
            //查询事件
            qryTabData(){
                const hasToolbarValue =this.selparam && this.textparam !== null && this.textparam !== undefined && String(this.textparam).trim() !== ''
                this.page =1
                this.getTabData(
                    'parentno',
                    this.treeid,
                    hasToolbarValue ? this.selparam : '',
                    hasToolbarValue ? this.textparam : '',
                    '',
                    '',
                    this.buildHeaderQueryCondition()
                )
            },
            // 获取 树形控件数据
            getData() {  
                var vm=this;
                this.loadingtree=true
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getElTreeData' ,
                    data: {p_table:'v_sys_base'}
                }).then(function(res){                  
                    vm.treeData =res.result   
                    if(res.result.length > 0 ){
                        //'nextTick()' 下次dom更新时触发回调函数
                        vm.$nextTick(() =>{
                            //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                            vm.$refs.eltree.setCurrentKey(vm.treeid)
                            vm.expkeys.push(vm.treeid)
                            //  let node = vm.$refs.eltree.getNode(vm.treeid); // 通过节点id找到对应树节点对象       
                            //  node.loaded = false;
                            //  node.expand();
                        })
                    }  
                    vm.loadingtree =false           
                })                              
            },
            //获取表列头字段
            getTabCol(){
                var vm=this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','19','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                    vm.initCol =res.result || []
                    return vm.loadInitialFieldSettings().then(() => {
                        const fieldRows =vm.sortFieldRows(vm.initCol)
                        vm.tableCol =[]
                        vm.vueCol =[]
                        let rownumColumn = null
                        fieldRows.forEach(item => {
                            const key = item.key || item.KEY || item.FLDNO
                            if (!key) return
                            const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                            vm.tableCol.push({
                                title,
                                key,
                                align: item.align,
                                width: item.width,
                                thide: item.THIDE,
                                fhide: item.FHIDE,
                                edcss: item.EDCSS,
                                disabled: item.DISABLED,
                                sortable: item.SORTABLE,
                            })
                            if (String(key).toUpperCase() === 'RN') {
                                rownumColumn = {
                                    field: key,
                                    key,
                                    title: vm.$LANG('0310', '序号'),
                                    width: 55,
                                    align: 'center',
                                    fixed: 'left',
                                    sortable: false,
                                    renderHeaderCell: ({column}) => (
                                        <div>
                                            <div style="margin-top:3px;">{column.title}</div>
                                            <el-link on-click={() => vm.rowShow()} underline={false} style="font-size:12px;color:#404eff;height:30px;">
                                                <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light">
                                                    <i class="iconfont icon-shanchu1"></i>
                                                </el-tooltip>
                                            </el-link>
                                        </div>
                                    ),
                                    renderBodyCell: ({row}) => <span style="color:#1890ff;">{row[key]}</span>,
                                }
                                return
                            }
                            if (String(item.THIDE).toUpperCase() !== 'N') return
                            const column = {
                                field: key,
                                key,
                                title,
                                align: item.align,
                                width: Number(item.width) || 120,
                                thide: item.THIDE,
                                fhide: item.FHIDE,
                                edcss: item.EDCSS,
                                disabled: item.DISABLED,
                                sortable: key !== 'RN',
                                ellipsis: { showTitle: true },
                                renderHeaderCell: ({column: currentColumn}) => (
                                    <div>
                                        <div style="margin-top:3px;display:flex;white-space:nowrap;">
                                            {currentColumn.title}
                                        </div>
                                        <div style="display:flex;">
                                            <input
                                                disabled={String(item.EDCSS).toLowerCase() === 'image'}
                                                value={vm.v_inputrow[key] || ''}
                                                on-keydown={(event) => vm.enterDown(event)}
                                                on-input={(event) => vm.inputChg(event, key)}
                                                style="padding:0px;margin-top:1px;width:100%;height:28px;"
                                            />
                                        </div>
                                    </div>
                                ),
                                renderBodyCell: ({row}) => row[key],
                            }
                            vm.vueCol.push(column)
                        })
                        if (rownumColumn) vm.vueCol.unshift(rownumColumn)
                        vm.vueCol.push({
                            field: 'oper0',
                            key: 'oper',
                            title: vm.$LANG('0330', '操作'),
                            width: 130,
                            align: 'center',
                            fixed: 'right',
                            renderBodyCell: ({row}) => (
                                <div>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.disabled} on-click={() => this.editRec(row)} underline={false}>
                                        <span style="font-size:12px;margin-right:10px;">{this.$LANG('1639', '编辑')}</span>
                                    </el-link>
                                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.disabled} on-click={() => this.delRec(row)} underline={false}>
                                        <span style="font-size:12px;">{this.$LANG('0131', '删除')}</span>
                                    </el-link>
                                </div>
                            ),
                        })
                        vm.applyFieldSettingRows()
                        return res
                    })
                });
            },
 
            //获取表数据
            getTabData(v_key,v_value,v_key2,v_value2,v_key3,v_value3,v_cond=''){
                var vm=this
                this.loading =true
                getTabColOrData(this.v_url,'v_sys_base',v_key,v_value,v_key2,v_value2,v_key3,v_value3,v_cond).then((res) => {
                    //保存取到 所有数据
                    vm.allData =res.result
                    vm.dataCount =res.result.length //总条数
                    // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
                    if (res.result.length < vm.pageSize){
                        vm.baseData = vm.allData
                    }else{
                        
                        if (this.page >1){
                            this.changePage(this.page)
                        }else{
                            this.baseData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
                        }
                    }
                    this.loading =false
                    //setTimeout(()=>{this.loading =false},2000) //测试效果
                    this.$nextTick(() => {
                        const table = this.$refs.tabref
                        if (table && typeof table.doLayout === 'function') table.doLayout()
                    })
                });               
            }
        }
    }
</script>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple; 
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>
<style scoped lang="less">
    .item-width  {
        width: 48%;
        height: 20px !important;
    }
</style>
